import styles from "./styles.module.scss";

interface IProps {
  tagText: string;
  size?: number;
  fontSize?: number;
}

export const Tag = ({ tagText, fontSize = 14, size = 24 }: IProps) => {
  const displayTag =
    tagText.length > 15 ? `${tagText.substring(0, 15)}...` : tagText;

  return (
    <div
      style={{ height: `${size}px`, fontSize: `${fontSize}px` }}
      className={styles.tag}
    >
      {displayTag}
    </div>
  );
};
